import { ApiCall } from "components/common/services/ApiServices";
import type {
  WhatsAppDataProps,
} from "../annotations/WhatsAppAnnotations";
import { AJ_WEB_CONNECTOR } from "Constants";
import { GET_WHATSAPP_MESSAGES } from "../../../../routes/ApiEndpoints";

/**
 * Fetch messages based on personID.
 */
export const FetchMessages = async (
  whatsAppData: WhatsAppDataProps
) => {
  const response = await ApiCall.service(
    GET_WHATSAPP_MESSAGES,
    "POST",
    whatsAppData,
    false,
    AJ_WEB_CONNECTOR
  );

  return response;
};
